import { LicenseAssignToAdmin, LicenseTypeSummary } from 'mbs-ui-shared@models/License';
import { createAction, props } from '@ngrx/store';
import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { StoreTypes } from 'mbs-ui-shared@store/storeTypes.enum';
import { PermissionFlags } from 'mbs-ui-shared@models/PermissionFlags';

export const setLicenseTypes = createAction(
  `[${StoreTypes.Licenses}] Set Licenses`,
  props<{
    licenseTypes: LicenseTypeSummary[];
  }>()
);
export const loadLicenseTypes = createAction(`[${StoreTypes.Licenses}] Load Licenses`);

export const setPermissionFlags = createAction(
  `[${StoreTypes.Licenses}] Set Permission Flags`,
  props<{
    permissionFlags: PermissionFlags;
  }>()
);
export const loadPermissionFlags = createAction(
  `[${StoreTypes.Licenses}] Load Permission Flags`,
  props<{
    force?: boolean;
  }>()
);

export const setBalance = createAction(
  `[${StoreTypes.Licenses}] Set Balance`,
  props<{
    balance: Balance;
  }>()
);
export const loadBalance = createAction(`[${StoreTypes.Licenses}] Load Balance`);

export const setLoading = createAction(`[${StoreTypes.Licenses}] Set Loading`, props<{ loading: boolean }>());

export const setAssignedLicense = createAction(`[${StoreTypes.Licenses}] Set Assigned License`, props<{ license: LicenseAssignToAdmin }>());
